<div class="container-fluid user-activity-dashboard">
  <div class="activity-page-header">
    <div>
      <h5 class="home-title">{{ getUserName() }} activity</h5>
      <p class="home-subtitle">Reviews, posts and hypocrisy activity in one place</p>
    </div>
    <button type="button" class="btn btn-primary btn-dashboard" (click)="goBack()">Back</button>
  </div>

  <section class="activity-overview">
    <div class="activity-profile">
      @if (getUserAvatar()) {
        <img class="activity-avatar" [src]="getUserAvatar()" [alt]="getUserName()">
      } @else {
        <div class="activity-avatar activity-avatar-fallback">{{ getUserInitials() }}</div>
      }
      <div class="activity-profile-copy">
        <span class="activity-eyebrow">User activity dashboard</span>
        <h4>{{ getUserName() }}</h4>
        <p class="email-display">{{ (user?.email | lowercaseEmail) || 'No email available' }}</p>
        <div class="activity-user-tags">
          @if (user?.type) {
            <span>{{ user.type }}</span>
          }
          @if (user?.status) {
            <span class="status-tag">{{ user.status }}</span>
          }
        </div>
      </div>
    </div>

    <div class="activity-stats">
      <button type="button" class="activity-stat reviews-stat" (click)="activeTab = 'reviews'">
        <span class="activity-stat-icon"><i class="las la-star"></i></span>
        <span><strong>{{ parameters.length }}</strong><small>Reviews</small></span>
      </button>
      <button type="button" class="activity-stat posts-stat" (click)="activeTab = 'posts'">
        <span class="activity-stat-icon"><i class="las la-file-alt"></i></span>
        <span><strong>{{ posts.length }}</strong><small>Posts</small></span>
      </button>
      <button type="button" class="activity-stat hypocrisy-stat" (click)="activeTab = 'hypocrisy'">
        <span class="activity-stat-icon"><i class="las la-exchange-alt"></i></span>
        <span><strong>{{ hypocrisies.length }}</strong><small>Hypocrisy</small></span>
      </button>
    </div>
  </section>

  <section class="activity-content">
    <nav class="activity-tabs" aria-label="User activity sections">
      <button type="button" [class.active]="activeTab === 'reviews'" (click)="activeTab = 'reviews'">
        Reviews <span>{{ parameters.length }}</span>
      </button>
      <button type="button" [class.active]="activeTab === 'posts'" (click)="activeTab = 'posts'">
        Posts <span>{{ posts.length }}</span>
      </button>
      <button type="button" [class.active]="activeTab === 'hypocrisy'" (click)="activeTab = 'hypocrisy'">
        Hypocrisy <span>{{ hypocrisies.length }}</span>
      </button>
    </nav>

    @if (loading) {
      <div class="activity-empty">
        <i class="las la-circle-notch la-spin"></i>
        <h5>Loading activity</h5>
      </div>
    } @else {
      @if (activeTab === 'reviews') {
        @if (parameters.length) {
          <div class="table-responsive applicants-details overflow-x-visible activity-table">
            <table class="table table-bordered user-table">
              <thead>
                <tr>
                  <th scope="col">Entity</th>
                  <th scope="col">Category</th>
                  <th scope="col">Ratings</th>
                  <th scope="col">Review</th>
                  <th scope="col">Submitted</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (param of parameters; track param.id; let i = $index) {
                  <tr class="client">
                    <td><strong>{{ param.entity?.entityName || '—' }}</strong></td>
                    <td><span class="category-chip">{{ param.category?.categoryName || '—' }}</span></td>
                    <td>
                      <div class="table-ratings">
                        @for (rating of param.value || []; track $index; let ratingIndex = $index) {
                          <div class="table-rating" [ngClass]="'table-rating-' + ratingIndex">
                            <span>{{ ratingLabels[ratingIndex] || rating.name || ('Rating ' + (ratingIndex + 1)) }}</span>
                            <strong>{{ rating.score ?? rating.rating ?? '—' }}</strong>
                          </div>
                        }
                      </div>
                    </td>
                    <td class="review-copy">{{ param.message || 'No written review' }}</td>
                    <td class="text-nowrap">{{ param.createdAt ? (param.createdAt | date:'mediumDate') : '—' }}</td>
                    <td class="action">
                      <div class="dropdown">
                        <button type="button" class="btn header-item waves-effect btn-dropdown"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <span class="mr-3 text-primary py-2 text-nowrap">
                            View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i>
                          </span>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right animate slideIn py-0 rounded-1">
                          <a class="dropdown-item text-primary border-bottom py-2 text-nowrap"
                            (click)="openReviewModal(param, reviewDetailsModal)">
                            <i class="las la-eye mb-1 la-lg align-middle mr-0"></i> View
                          </a>
                          <a class="dropdown-item text-danger py-2 text-nowrap" (click)="remove(param.id, i)">
                            <i class="las la-trash mb-1 la-lg align-middle mr-0"></i> Delete
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="activity-empty">
            <i class="las la-star"></i>
            <h5>No reviews yet</h5>
            <p>This user has not submitted any reviews.</p>
          </div>
        }
      }

      @if (activeTab === 'posts') {
        @if (posts.length) {
          <div class="post-grid">
            @for (item of posts; track item.story?.id || $index) {
              <article class="activity-card post-card">
                <header class="activity-card-header">
                  <div>
                    <span class="activity-card-type"><i class="las la-file-alt"></i> Post</span>
                    <h5>{{ getEntityName(item) }}</h5>
                  </div>
                  <time>{{ item.story?.createdAt ? (item.story.createdAt | date:'mediumDate') : '—' }}</time>
                </header>
                @if (getMediaUrl(item.story?.media)) {
                  <div class="activity-media">
                    @if (isVideo(item.story?.media)) {
                      <video controls preload="metadata" [src]="getMediaUrl(item.story.media)"></video>
                    } @else {
                      <img [src]="getMediaUrl(item.story.media)" alt="Post attachment">
                    }
                  </div>
                }
                <p class="activity-card-copy">{{ item.story?.content || 'No text content was provided.' }}</p>
              </article>
            }
          </div>
        } @else {
          <div class="activity-empty">
            <i class="las la-file-alt"></i>
            <h5>No posts yet</h5>
            <p>This user has not published any posts.</p>
          </div>
        }
      }

      @if (activeTab === 'hypocrisy') {
        @if (hypocrisies.length) {
          <div class="hypocrisy-list">
            @for (item of hypocrisies; track item.hypocrisy?.id || $index) {
              <article class="activity-card hypocrisy-card">
                <header class="activity-card-header">
                  <div>
                    <span class="activity-card-type hypocrisy-label"><i class="las la-exchange-alt"></i> Hypocrisy</span>
                    <h5>{{ getEntityName(item) }}</h5>
                  </div>
                  <time>{{ item.hypocrisy?.createdAt ? (item.hypocrisy.createdAt | date:'mediumDate') : '—' }}</time>
                </header>
                <div class="comparison-grid">
                  <section class="comparison-side past-side">
                    <span class="comparison-label">Past</span>
                    @if (getMediaUrl(item.hypocrisy?.pastMedia)) {
                      <div class="comparison-media">
                        @if (isVideo(item.hypocrisy?.pastMedia)) {
                          <video controls preload="metadata" [src]="getMediaUrl(item.hypocrisy.pastMedia)"></video>
                        } @else {
                          <img [src]="getMediaUrl(item.hypocrisy.pastMedia)" alt="Past attachment">
                        }
                      </div>
                    }
                    <p>{{ item.hypocrisy?.pastContent || 'No past statement provided.' }}</p>
                  </section>
                  <div class="comparison-arrow"><i class="las la-long-arrow-alt-right"></i></div>
                  <section class="comparison-side present-side">
                    <span class="comparison-label">Present</span>
                    @if (getMediaUrl(item.hypocrisy?.presentMedia)) {
                      <div class="comparison-media">
                        @if (isVideo(item.hypocrisy?.presentMedia)) {
                          <video controls preload="metadata" [src]="getMediaUrl(item.hypocrisy.presentMedia)"></video>
                        } @else {
                          <img [src]="getMediaUrl(item.hypocrisy.presentMedia)" alt="Present attachment">
                        }
                      </div>
                    }
                    <p>{{ item.hypocrisy?.presentContent || 'No present statement provided.' }}</p>
                  </section>
                </div>
              </article>
            }
          </div>
        } @else {
          <div class="activity-empty">
            <i class="las la-exchange-alt"></i>
            <h5>No hypocrisy activity yet</h5>
            <p>This user has not published any hypocrisy comparisons.</p>
          </div>
        }
      }
    }
  </section>
</div>

<ng-template #reviewDetailsModal>
  @if (selectedReview) {
    <div class="review-modal">
      <div class="modal-header review-modal-header">
        <div>
          <p class="review-modal-kicker">Review details</p>
          <h4 class="modal-title">{{ selectedReview.entity?.entityName || 'Entity review' }}</h4>
        </div>
        <button type="button" class="close review-modal-close" aria-label="Close" (click)="modalRef?.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body review-modal-body">
        <div class="review-summary-grid">
          <div class="review-summary-item">
            <span class="review-field-label">Entity</span>
            <strong>{{ selectedReview.entity?.entityName || '—' }}</strong>
          </div>
          <div class="review-summary-item">
            <span class="review-field-label">Category</span>
            <strong>{{ selectedReview.category?.categoryName || '—' }}</strong>
          </div>
          <div class="review-summary-item">
            <span class="review-field-label">Reviewer</span>
            <strong>{{ selectedReview.user?.fullName || '—' }}</strong>
            @if (selectedReview.user?.email) {
              <span class="review-secondary email-display">{{ selectedReview.user.email | lowercaseEmail }}</span>
            }
          </div>
          <div class="review-summary-item">
            <span class="review-field-label">Submitted</span>
            <strong>{{ selectedReview.createdAt ? (selectedReview.createdAt | date:'medium') : '—' }}</strong>
          </div>
        </div>

        <section class="review-section">
          <h5>Ratings</h5>
          <div class="review-ratings-grid">
            @for (rating of selectedReview.value || []; track $index; let i = $index) {
              <div class="review-rating-card" [ngClass]="'rating-' + i">
                <span>{{ ratingLabels[i] || rating.name || ('Rating ' + (i + 1)) }}</span>
                <strong>{{ rating.score ?? rating.rating ?? '—' }}</strong>
              </div>
            }
          </div>
        </section>

        <section class="review-section">
          <h5>Review</h5>
          <div class="review-message">
            {{ selectedReview.message || 'No written review was provided.' }}
          </div>
        </section>
      </div>

      <div class="modal-footer review-modal-footer">
        <button type="button" class="btn btn-primary px-4" (click)="modalRef?.hide()">Close</button>
      </div>
    </div>
  }
</ng-template>
